export default "__VITE_ASSET__BCaw5Wpo__"